import createAuthAxios from 'common/lib/createAuthAxios';
import copyMagicLog from 'common/components/CopyMagic/shared/copyMagicLog';
import type { MessageType } from 'common/components/CopyMagic/contexts/MessagesContext/MessagesContext.types';

type PostMessageRatingsRequest = {
  message: MessageType;
  positiveFeedback: boolean;
};

const postMessageRatings = async ({ message, positiveFeedback }: PostMessageRatingsRequest) => {
  if (!message.contentId) return;

  const authAxios = createAuthAxios();

  const url = `/api/admin/copy_magic/message_ratings`;
  const params = {
    content_id: message.contentId,
    rating: positiveFeedback ? 'positive' : 'negative',
    rated_at: new Date().toISOString(),
  };

  try {
    await authAxios.post(url, params);
  } catch (error) {
    copyMagicLog(error, { level: 'error' });
  }
};

export default postMessageRatings;
